import { useForm } from "react-hook-form";
import { useRef } from "react";
import { isEqual } from "lodash";

const useFilterForm = ({ value, onChange }) => {
	const form = useForm({
		defaultValues: value
	});

	const { watch } = form;
	const previousValuesRef = useRef(value);

	watch(values => {
		if (!isEqual(values, previousValuesRef.current)) {
			previousValuesRef.current = values;
			onChange(values);
		}
	});

	return form;
};

export default useFilterForm;
